import { useState, useEffect } from 'react'
import '../inquiry/telephonic/telephonic.scss'
import { useDispatch, useSelector } from 'react-redux'
import { UI_CONSTANT, ROUTES_PATH, numbers, monthList } from '../../utility/constants'
import PageDropdown from '../../components/page-dropdown/PageDropdown'
import { FilterMatchMode, FilterService } from 'primereact/api'
import ParentDataTable from '../../components/data-table/ParentDataTable'
import './billingHistory.scss'
import BreadCrumbs from '../../components/breadcrumb/Breadcrumb'
import { Calendar } from 'primereact/calendar'
import ArrowDownIcon from '../../components/svg/ArrowDown'
import { getFacultyMonthBilling } from '../../store/builders/faculty/facultybilling.builder'
import TableDateInput from '../../components/table-date-input/TableDateInput'
import { capitalizeFirstLetter, convertTZToDate, dynamicCustomFilter } from '../../utility/genricFunction'
import Loader from '../../components/loader/Loader'
import { setCurrentMonthNumber, setCurrentYear } from '../../store/slice/faculty/facultybilling.slice'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'


const BillingHistory = () => {
  const dispatch = useDispatch()
  const { user } = useSelector((state) => state.auth) || {}

  const userRole = user?.result?.userData?.roleName

  const { loading, currentMonthNumber, currentYear, facultyMonthBillData } = useSelector(
    (state) => state.facultyMonthBilling,
  )

  const [selectedNumber, setSelectedNumber] = useState(numbers[0].value)
  const [month, setMonth] = useState(new Date().getMonth() + 1)
  const [year, setYear] = useState(new Date().getFullYear())
  const [isLocked, setIsLocked] = useState(true)
  const [date, setDate] = useState(`${monthList[currentMonthNumber - 1]} ${currentYear}`)


  const facultyId = user?.result?.facultyId
  const monthAmount =
    facultyMonthBillData &&
    facultyMonthBillData?.timeTable?.reduce((acc, item) => {
      if (item?.totalAmount !== null) {
        return acc + item?.totalAmount
      }
      return acc
    }, 0)

  useEffect(() => {
    dispatch(getFacultyMonthBilling({ facultyId, month, year }))
  }, [])


FilterService.register('dynamic_custom', (value, filter, filterMeta) => {
    return dynamicCustomFilter(value, filter, filterMeta?.matchMode || 'CONTAINS')
  })

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    date: { value: null, matchMode: FilterMatchMode.EQUALS },
    courseName: { value: null, matchMode: 'dynamic_custom' },
    branchName: { value: null, matchMode: 'dynamic_custom' },
    amount: { value: null, matchMode: 'dynamic_custom' },
    totalHours: { value: null, matchMode: 'dynamic_custom' },
    totalAmount: { value: null, matchMode: 'dynamic_custom' },
  })

  const nameBody = (facultyMonthBillData) => {
    const representative = capitalizeFirstLetter(facultyMonthBillData?.branchName)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )

  }


  const dateBody = (facultyMonthBillData) => {
    const representative = facultyMonthBillData?.date && convertTZToDate(facultyMonthBillData?.date)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }

  const [selected, setSelected] = useState(false) // Initial state based on prop

  const [filteredData, setFilteredData] = useState([])
  const [filterNumber] = useState(false)

  const handleClick = () => {
    setSelected(!selected)
  }

  useEffect(() => {
   facultyMonthBillData &&  setFilteredData(facultyMonthBillData?.timeTable)
  }, [facultyMonthBillData])

  const onFilter = (event) => {
    const newFilters = { ...filters, ...event.filters }
    setFilters(newFilters)
    const filtered = filterData(facultyMonthBillData?.timeTable, newFilters)
    setFilteredData(filtered)
  }

  const filterData = (data, filters) => {
    return data.filter((item) => {
      return Object.keys(filters).every((key) => {
        if (!filters[key].value) return true
        const value = item[key]
        const filterValue = filters[key].value.toLowerCase().trim()
        return value && value.toString().toLowerCase().includes(filterValue)
      })
    })
  }

  const columns = [
    {
      sortable: true,
      field: 'date',
      header: 'Date',
      showFilterMenu: false,
      filterMenuStyle: { width: '12rem' },
      style: { minWidth: '12rem' },
      filterPlaceholder: 'Search by date...',
      filter: true,
      filterElement: TableDateInput,
      body:dateBody
    },
    {
      sortable: true,
      field: 'courseName',
      header: 'Course',
      filter: true,
      filterDisplay: 'row',
      filterPlaceholder: 'Search by course...',
      style: { minWidth: '12rem' },
    },
    {
      sortable: true,
      field: 'branchName',
      header: 'Branch',
      filter: true,
      filterDisplay: 'row',
      filterPlaceholder: 'Search by branch...',
      style: { minWidth: '12rem' },
      body: nameBody,
    },
    {
      sortable: true,
      field: 'amount',
      header: 'Rate per Hour',
      style: { minWidth: '12rem' },
      filter: true,
      filterPlaceholder: 'Search by rate...',
    },
    {
      sortable: true,
      field: 'totalHours',
      header: 'Hours',
      showFilterMenu: false,
      filterMenuStyle: { width: '14rem' },
      style: { minWidth: '12rem' },
      filter: true,
      filterPlaceholder: 'Search by hours...',
    },
    {
      sortable: true,
      field: 'totalAmount',
      header: 'Total',
      showFilterMenu: false,
      filterMenuStyle: { width: '14rem' },
      style: { minWidth: '12rem' },
      filter: true,
      filterPlaceholder: 'Search by totals...',
    },
  ]

  const breadCrumbsArr = [
    {
      title: UI_CONSTANT.BILLING_HISTORY.LABEL_BILLING_HISTORY,
      link: null,
    },
    {
      title: UI_CONSTANT.DASHBOARD,
      link: ROUTES_PATH.FACULTY_DASHBOARD,
    },
    {
      title: UI_CONSTANT.BILLING_HISTORY.LABEL_BILLING_HISTORY,
      link: ROUTES_PATH.BILLING_HISTORY,
    },
  ]

  function formatDate(date) {
    const monthIndex = date.getMonth()
    const monthNumber = monthIndex + 1
    const month = monthList[date.getMonth()]
    const year = date.getFullYear()
    setMonth(monthNumber)
    setYear(year)
    return `${month} ${year}`
  }

  function extractMonthAndYear(dateString) {
    const date = new Date(dateString);
  
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
  
    return { month, year };
  }

  function handleDate(date) {

    const {month, year} = extractMonthAndYear(date)


    dispatch(getFacultyMonthBilling({ facultyId, month, year }))
    dispatch(setCurrentMonthNumber(month))
    dispatch(setCurrentYear(year))

    setDate(formatDate(date))
  }

  const toggleLock = () => {
    setIsLocked(!isLocked)
  }

  return (
    <>
      {loading && <Loader loading={loading} />}
      {<Loader loading={loading} /> && (
        <div className={`course-list }`}>
          <div className='filter-bar-wraper'>
            <div className='subheader'>
              <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
              {userRole == UI_CONSTANT.ADMIN_ROLE ||
                (userRole == UI_CONSTANT.BRANCH_ROLE && (
                  <button
                    type='button'
                    onClick={handleClick}
                    className={selected ? 'bill-pay-selected' : 'bill-pay-unselected'}
                  >
                    {selected ? UI_CONSTANT.PAID : UI_CONSTANT.UNPAID}
                  </button>
                ))}
            </div>
          </div>

          <div className='group-parent'>
            <div className='frame-wrapper'>
              <div className='course-list-wrapper bill-head'>
                <span className='div-img flex flex-column'>
                  <div className='div-img-wrapper flex align-center'>
                    <b className='course-list-bill'>{date}</b>
                    <div className='billing-history-calendar-wrapper flex flex-column'>
                      <Calendar
                        className='calendar-container'
                        showIcon
                        icon={<ArrowDownIcon />}
                        iconPos='right'
                        value={date}
                        onChange={(e) => handleDate(e.value)}
                        view='month'
                        dateFormat='mm/yy'
                      />
                    </div>
                  </div>
                </span>
                {isLocked && <LockOutlinedIcon className='billing-history-lock' onClick={toggleLock} />}
                <div className={`bill-div ${!isLocked ? '' : 'blur'}`}>
                  <p className='bill-amt-txt'>Total</p>
                  <p className='bill-amt'>{`₹${monthAmount}` || '₹0'}</p>
                </div>
              </div>
            </div>
            <div className='flex page-drop-div'>
              <p className='page-sidetext'>{UI_CONSTANT.TABLE_HEADER_SAW}</p>
              <PageDropdown
                options={numbers}
                selectedValue={selectedNumber}
                onChange={(e) => setSelectedNumber(e.value)}
                className='w-full md:w-14rem small-dropdown'
              />
              <p className='page-endtext'>{UI_CONSTANT.TABLE_HEADER_ENTRIES}</p>
            </div>

            <div className={`table-card ${!isLocked ? '' : 'blur'}`}>
              <ParentDataTable
                value={filteredData}
                rows={filterNumber ? filteredData.length : selectedNumber}
                filters={filters}
                // loading={loading}
                columns={columns}
                onFilter={onFilter}
              />
            </div>
          </div>

          {/* <BranchTable /> */}
          {/* </div> */}
        </div>
      )}
    </>
  )
}

export default BillingHistory
